import { c as _c } from "react/compiler-runtime";
import { useContext } from 'react';
import useSWR from 'swr';
import { CLI_CLIENT_LABEL_DASHBOARD_ONBOARDING } from '../../../../../domain/cli-client-labels';
import APIMethodKeys from '../../client/APIMethodKeys';
import HookdeckAPI from '../../client/Hookdeck';
import { CliClient } from '../../../../../typings/CliClient.interface';
import { GlobalContext } from '../contexts/GlobalContext';
import { DashboardContext } from '../scenes/DashboardScene/DashboardContext';
async function getOrCreateCliClientForLogin(api: HookdeckAPI, user_id: string): Promise<CliClient> {
  const list = await api.cli_clients.list({
    user_id
  });
  const existing = list.models.find((client: CliClient) => !client.invalidated_at && client.device_name === CLI_CLIENT_LABEL_DASHBOARD_ONBOARDING);
  if (existing) {
    return existing;
  }
  return api.cli_clients.create({
    device_name: CLI_CLIENT_LABEL_DASHBOARD_ONBOARDING
  });
}
export function useCliLoginCommand() {
  const $ = _c(11);
  const {
    HookdeckAPI
  } = useContext(GlobalContext);
  const {
    user,
    team
  } = useContext(DashboardContext);
  const user_id = user?.id;
  const team_id = team?.id;
  const awaiting_user = Boolean(team_id && !user_id);
  let t0;
  if ($[0] !== team_id || $[1] !== user_id) {
    t0 = user_id && team_id ? [APIMethodKeys.cli_clients.list({
      user_id
    }), team_id, user_id, "cli_login_command"] : null;
    $[0] = team_id;
    $[1] = user_id;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const swr_key = t0;
  let t1;
  if ($[3] !== HookdeckAPI || $[4] !== user_id) {
    t1 = () => {
      if (!user_id) {
        throw new Error("CLI login: missing user id");
      }
      return getOrCreateCliClientForLogin(HookdeckAPI, user_id);
    };
    $[3] = HookdeckAPI;
    $[4] = user_id;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      shouldRetryOnError: false
    };
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const {
    data,
    error,
    isLoading
  } = useSWR(swr_key, t1, t2);
  const login_command = data ? `hookdeck login --cli-key ${data.key}` : null;
  const t3 = awaiting_user || isLoading;
  let t4;
  if ($[7] !== error || $[8] !== login_command || $[9] !== t3) {
    t4 = {
      login_command,
      error,
      is_loading: t3
    };
    $[7] = error;
    $[8] = login_command;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}